var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export function groupArray(arr, n) {
    var group = [];
    for (var i = 0, j = 0; i < arr.length; i++) {
        if (i >= n && i % n === 0)
            j++;
        group[j] = group[j] || [];
        group[j].push(arr[i]);
    }
    return group;
}
export var removeFromArray = function (arr) {
    var itemsToRemove = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        itemsToRemove[_i - 1] = arguments[_i];
    }
    if (!arr)
        return arr;
    for (var _a = 0, itemsToRemove_1 = itemsToRemove; _a < itemsToRemove_1.length; _a++) {
        var item = itemsToRemove_1[_a];
        var i = arr.indexOf(item);
        while (i >= 0) {
            arr.splice(i, 1);
            i = arr.indexOf(item);
        }
    }
    return arr;
};
export var joinTruthy = function (separator) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return args.filter(function (x) { return x; }).join(separator);
};
export var joinTruthyFactory = function (separator) {
    if (separator === void 0) { separator = ','; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return joinTruthy.apply(void 0, __spreadArray([separator], args));
    };
};
export var joinTruthyWithSpace = joinTruthyFactory(' ');
